import {map as _map} from 'lodash';
import PropTypes from 'prop-types';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';
import {
	LayersControlGroup,
	LayersControlGroupContent,
	LayersControlGroupHeader,
	LayersControlGroupItem,
} from '../../components';

const Presentation = ({activeLayerKey, availableLayers, onLayerChange}) => {
	const options = _map(availableLayers, layer => (
		<ButtonSwitchOption
			key={layer.key}
			value={layer.key}
			active={layer.key === activeLayerKey}
		>
			{layer.name}
		</ButtonSwitchOption>
	));

	return (
		<LayersControlGroup>
			<LayersControlGroupHeader>Background layers</LayersControlGroupHeader>
			<LayersControlGroupContent>
				<LayersControlGroupItem>
					<ButtonSwitch onClick={onLayerChange} ghost>
						{options}
					</ButtonSwitch>
				</LayersControlGroupItem>
			</LayersControlGroupContent>
		</LayersControlGroup>
	);
};

Presentation.propTypes = {
	activeLayerKey: PropTypes.string,
	availableLayers: PropTypes.object,
	onLayerChange: PropTypes.func,
};

export default Presentation;
